module.exports = __webpack_public_path__ + "static/media/user-blue.972f9623.svg";